import { topicHasField, type ReviewTopic } from './project-review-model';

/** An exact comparison takes precedence over legacy, potentially ambiguous field links. */
export function topicMatchesReviewLink(
  topic: ReviewTopic,
  params: URLSearchParams,
): boolean {
  if (params.get('order') && topic.order.order_ref !== params.get('order'))
    return false;
  if (params.has('exception'))
    return topic.tasks.some((task) => task.id === params.get('exception'));
  return topicHasField(topic, params.get('field'));
}

/** Only the local inbox can supply a return destination. */
export function inboxReturnPath(params: URLSearchParams): string | null {
  const value = params.get('from');
  return value === '/inbox' || value?.startsWith('/inbox?') ? value : null;
}

/** Existing Inbox links continue to open the dedicated pre-site review card. */
export function isPreSiteReviewField(field: string | null): boolean {
  return [
    'assessment_coverage',
    'measurement_applicability',
    'stage1_applicability',
  ].includes(field ?? '');
}
